/* eslint-disable @typescript-eslint/naming-convention */
import type { SegmentAnalytics } from '@lemonade-hq/cdk';
import { Cookie, getJSONCookie } from '@lemonade-hq/nuiza';

declare global {
  interface Window {
    analytics?: Partial<SegmentAnalytics>; // eslint-disable-line functional/prefer-readonly-type
    // eslint-disable-next-line functional/prefer-readonly-type
    mixpanel?: {
      readonly start_session_recording: () => void;
      readonly get_session_recording_url: () => string | null;
    };
    dataLayer: unknown[]; // eslint-disable-line functional/prefer-readonly-type
  }
}

type CampaignUTM = 'campaign' | 'content' | 'medium' | 'source' | 'term';

interface GetContextCampaignsReturnType {
  readonly campaign?: Partial<Record<CampaignUTM, string>>;
}

// generate campaign object in segment context with UTMs values from params or cookies
export function getContextCampaigns(): GetContextCampaignsReturnType | undefined {
  const UTMs = ['source', 'medium', 'campaign', 'content', 'term', 'unique_id'] as CampaignUTM[];
  const utmValues = getJSONCookie(Cookie.UTMs);
  const searchParams = new URLSearchParams(window.location.search);

  const campaign = UTMs.reduce(
    (acc, utm) => {
      const value = searchParams.get(`utm_${utm}`) ?? utmValues[`utm_${utm}`] ?? '';
      return value.length > 0 ? { ...acc, [utm]: value } : acc;
    },
    {} as Record<CampaignUTM, string>,
  );
  return Object.keys(campaign).length > 0 ? { campaign } : undefined;
}

// generate integrations object in context with Customer.io value from params or cookies
interface GetIntegrationsReturnType {
  readonly integrations?: Record<string, boolean>;
}

export function getIntegrations(userId?: string): GetIntegrationsReturnType {
  return { integrations: { 'Customer.io': (userId ?? window.analytics?.user?.().id?.()) != null } };
}

interface GetDefaultEventOptionsReturnType {
  readonly integrations?: Record<string, boolean>;
  readonly campaign?: Partial<Record<CampaignUTM, string>> | undefined;
}

const contextCampaigns = getContextCampaigns();

export function getDefaultEventOptions(userId?: string): GetDefaultEventOptionsReturnType {
  return {
    ...getIntegrations(userId),
    ...contextCampaigns,
  };
}
